<template>
  <el-dialog :title="reassign ? '改派司机' : '分派司机'" :visible.sync="visible" width="780px" append-to-body
    @close="handleClose">
    <div v-if="order" class="order-brief">
      订单 {{ order.id }} / {{ order.showTime }} / {{ order.number || 0 }}人
      <span v-if="order.telephone"> / {{ order.telephone }}</span>
    </div>
    <el-table v-loading="loading" :data="candidates" highlight-current-row max-height="420" @current-change="onSelect">
      <el-table-column label="类型" width="120" prop="label"></el-table-column>
      <el-table-column label="司机" width="100" prop="driverNo"></el-table-column>
      <el-table-column label="路线" width="120">
        <template slot-scope="scope">{{ scope.row.pathId | pathNameTransfer }}</template>
      </el-table-column>
      <el-table-column label="时段" width="120" prop="showTime"></el-table-column>
      <el-table-column label="余座" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.leftSeats != null">{{ scope.row.leftSeats }}/{{ scope.row.seats }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="可达/日末" min-width="150">
        <template slot-scope="scope">{{ scope.row.arriveTime | dateFormat('yyyy-MM-dd hh:mm') }}</template>
      </el-table-column>
    </el-table>
    <div v-if="!loading && !candidates.length" class="empty-tip">暂无可分派司机</div>
    <span slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" :disabled="!selected" :loading="submitting" @click="confirm">
        {{ reassign ? '确认改派' : '确认分派' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listEvAssignCandidates, assignEvOrder } from "@/api/ev_solver";

export default {
  name: "AssignDriverDialog",
  data() {
    return {
      visible: false,
      loading: false,
      submitting: false,
      order: null,
      reassign: false,
      candidates: [],
      selected: null
    };
  },
  methods: {
    open(order, reassign = false) {
      if (!order || !order.id) {
        return;
      }
      this.order = order;
      this.reassign = !!reassign;
      this.selected = null;
      this.candidates = [];
      this.visible = true;
      this.loadCandidates();
    },
    loadCandidates() {
      this.loading = true;
      listEvAssignCandidates(this.order.id)
        .then((res) => {
          this.candidates = res.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelect(row) {
      this.selected = row;
    },
    confirm() {
      if (!this.selected || !this.order) {
        return;
      }
      this.submitting = true;
      assignEvOrder({
        orderId: this.order.id,
        planType: this.selected.planType,
        planId: this.selected.planId,
        driverId: this.selected.driverId,
        reassign: this.reassign
      })
        .then((res) => {
          this.visible = false;
          this.$emit("success", {
            action: this.reassign ? "改派" : "分派",
            data: res.data
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleClose() {
      this.order = null;
      this.selected = null;
      this.candidates = [];
      this.submitting = false;
    }
  }
};
</script>

<style lang="less" scoped>
.order-brief {
  margin-bottom: 10px;
  color: #606266;
  font-size: 13px;
}

.empty-tip {
  padding: 24px 0;
  text-align: center;
  color: #909399;
}
</style>
